import { useTranslation } from '@/i18n';
import classnames from 'classnames/bind';
import { FC, PropsWithChildren, memo } from 'react';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

export type Props = {
  testId?: string;
  fullWidth?: boolean;
};

export const RequiredLabel: FC<PropsWithChildren<Props>> = memo(
  ({ children, testId, fullWidth = false }) => {
    const { t } = useTranslation();
    return (
      <div
        className={cx('container', {
          'full-width': fullWidth,
        })}
        data-testid={testId}
      >
        <span>{children}</span>
        <span className={cx(styles['required'])}>{t('required_label')}</span>
      </div>
    );
  }
);
RequiredLabel.displayName = 'ListViewRequiredLabel';
